import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import TimelineSection from "@/pages/home/components/TimelineSection";
import ReviewSection from "@/pages/home/components/ReviewSection";
import ChannelSection from "@/pages/home/components/ChannelSection";
import AboutSection from "@/pages/home/components/AboutSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopNav />
      <main>
        <Hero />
        <TimelineSection />
        <ReviewSection />
        <ChannelSection />
        <AboutSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}